import { appStage, appEnvironment } from 'helpers/constants';
import { datadogLogs } from '@datadog/browser-logs';
export * from './init';

const allowLogging = appStage === 'local' || appStage === 'dev' || appStage === 'staging';
let dogLogger: any;

if (appEnvironment === 'prod') {
  dogLogger = datadogLogs.createLogger('dogLogger');
}
/**
 * Logs values to the console
 * Accepts any number of arguments
 * @param args any[]
 */
function log(...args: any[]) {
  callLogger(console.log, ...args);
  if (appEnvironment === 'prod') {
    dogLogger.log(...args);
  }
}

/**
 * Displays logged values as a table
 * @param args
 */
function table(...args: any[]) {
  callLogger(console.table, ...args);
}

/**
 * Displays an error in the console
 * @param args
 */
function error(...args: any[]) {
  callLogger(console.error, ...args);
  if (appEnvironment === 'prod') {
    dogLogger.error(...args);
  }
}

/**
 * Displays a warning in the console
 * @param args
 */
function warn(...args: any[]) {
  callLogger(console.warn, ...args);
  if (appEnvironment === 'prod') {
    dogLogger.warn(...args);
  }
}

/**
 * Displays info to the console
 * @param args
 */
function info(...args: any[]) {
  callLogger(console.info, ...args);
}

/**
 * Checks if the service should log
 * @param fn
 * @param args
 */
function callLogger(fn: (...args: any[]) => void, ...args: any[]) {
  allowLogging && fn(...args);
}

export const Logger = {
  log,
  warn,
  info,
  error,
  table,
};

export { getDataForSettingIdentity } from './util';
